// Localization script for ymm app for different markets

 (() => {
  const configuredLocale = document.currentScript?.dataset.locale;
  const documentLocale = document.documentElement.lang;
  const currentLocale = (configuredLocale || documentLocale || '')
    .toLowerCase()
    .split('-')[0];

  const translationsByLocale = {
    ro: {
        exact: {
            '4x4 (система на задвижване на четирите колела)': '4x4 (sistem de tracțiune integrală)',
            'IMA (Integrated Motor Assist – интегрирана моторна помощ)': 'IMA (Integrated Motor Assist – asistență electrică integrată)',
            'Всички модели': 'Toate modelele',
            'Гранд Туризмо': 'Gran Turismo',
            'Джип/SUV': 'SUV/4x4',
            'Златна детелина': 'Quadrifoglio Oro',
            'Куатро': 'Quattro',
            'Лек автомобил за отдих (LAV)': 'Vehicul recreațional ușor (LAV)',
            'Многофункционално превозно средство (MPV)': 'Vehicul multifuncțional (MPV)',
            'С фарове за завиване': 'Cu lumini de viraj',
            'Хибрид 4x4': 'Hibrid 4x4'
        },
        phrases: [
            ["BI-XENON HEADLAMP WITH LED DRL'S", 'Far bi-xenon cu lumini de zi LED'],
            ['BI-XENON WITH CORNERING LIGHTS', 'Bi-xenon cu lumini de viraj'],
            ['BI-XENON WITHOUT CORNERING LIGHTS', 'Bi-xenon fără lumini de viraj'],
            ["HALOGEN HEADLAMPS WITH HALOGEN DRL'S", 'Faruri cu halogen și lumini de zi cu halogen'],
            ["HALOGEN HEADLAMPS WITH LED DRL'S", 'Faruri cu halogen și lumini de zi LED'],
            ["HALOGEN HEADLAMPS WITH DRL'S", 'Faruri cu halogen și lumini de zi'],
            ["HALOGEN HEADLIGHTS WITH LED DRL'S", 'Faruri cu halogen și lumini de zi LED'],
            ['SALOON HALOGEN HEADLIGHTS WITH DRL', 'Sedan cu faruri cu halogen și lumini de zi'],
            ['XENON HID WITH CORNERING LIGHTS', 'Xenon HID cu lumini de viraj'],
            ['XENON HID WITHOUT CORNERING LIGHTS', 'Xenon HID fără lumini de viraj'],
            ['SUV XENON HID WITH CORNERING LIGHTS', 'SUV cu xenon HID și lumini de viraj'],
            ["TWIN HEADLIGHT UNIT WITH DRL'S", 'Faruri duble cu lumini de zi'],
            ["TWIN HEADLIGHT UNIT WITHOUT DRL'S", 'Faruri duble fără lumini de zi'],
            ['HALOGEN SINGLE HEADLIGHT UNIT', 'Far simplu cu halogen'],
            ['HALOGEN TWIN HEADLIGHT UNIT', 'Faruri duble cu halogen'],
            ['HALOGEN WITH CORNERING LIGHTS', 'Halogen cu lumini de viraj'],
            ['HALOGEN WITHOUT CORNERING LIGHTS', 'Halogen fără lumini de viraj'],
            ["HALOGEN WITHOUT DRL'S", 'Halogen fără lumini de zi'],
            ["HALOGEN WITH DRL'S", 'Halogen cu lumini de zi'],
            ['HATCHBACK WITHOUT CORNERING LIGHTS', 'Hatchback fără lumini de viraj'],
            ['HATCHBACK WITH CORNERING LIGHTS', 'Hatchback cu lumini de viraj'],
            ['VAN WITHOUT CORNERING LIGHTS', 'Furgonetă fără lumini de viraj'],
            ['VAN WITH CORNERING LIGHTS', 'Furgonetă cu lumini de viraj'],
            ['CONVERTIBLE SINGLE HEADLAMP', 'Cabriolet cu un singur far'],
            ['CONVERTIBLE TWIN HEADLAMP', 'Cabriolet cu faruri duble'],
            ['CONVERTIBLE TWIN HEADLIGHT', 'Cabriolet cu faruri duble'],
            ['ESTATE HALOGEN SINGLE HEADLIGHT UNIT', 'Break cu un singur far cu halogen'],
            ['ESTATE HALOGEN TWIN HEADLIGHT UNIT', 'Break cu faruri duble cu halogen'],
            ['HATCHBACK HALOGEN SINGLE HEADLIGHT UNIT', 'Hatchback cu un singur far cu halogen'],
            ['HATCHBACK HALOGEN TWIN HEADLIGHT UNIT', 'Hatchback cu faruri duble cu halogen'],
            ['SALOON HALOGEN TWIN HEADLIGHT UNIT', 'Sedan cu faruri duble cu halogen'],
            ['PICK UP SINGLE HEADLIGHT UNIT', 'Pick-up cu un singur far'],
            ['COUPE (PROJECTOR HEADLIGHTS)', 'Coupe cu faruri cu lupă'],
            ['COUPE (N1 HEADLIGHTS)', 'Coupe cu faruri N1'],
            ['2 DOOR SALOON', 'Sedan cu 2 uși'],
            ['3 DOOR ESTATE', 'Break cu 3 uși'],
            ['4 DOOR SALOON', 'Sedan cu 4 uși'],
            ['5 DOOR ESTATE', 'Break cu 5 uși'],
            ['5 DOOR HATCHBACK', 'Hatchback cu 5 uși'],
            ['3 DOOR HALOGEN HEADLIGHTS', '3 uși, faruri cu halogen'],
            ['5 DOOR HALOGEN HEADLIGHTS', '5 uși, faruri cu halogen'],
            ['CABRIOLET HALOGEN HEADLIGHTS', 'Cabriolet cu faruri cu halogen'],
            ['CABRIOLET XENON HID', 'Cabriolet cu faruri xenon HID'],
            ['CONVERTIBLE BI-XENON', 'Cabriolet cu faruri bi-xenon'],
            ['CONVERTIBLE LED HEADLIGHTS', 'Cabriolet cu faruri LED'],
            ['CONVERTIBLE XENON HID', 'Cabriolet cu faruri xenon HID'],
            ['COUPE BI-HALOGEN', 'Coupe cu faruri bi-halogen'],
            ['COUPE BI-XENON', 'Coupe cu faruri bi-xenon'],
            ['COUPE ESTATE', 'Coupe break'],
            ['COUPE SINGLE HEADLAMP', 'Coupe cu un singur far'],
            ['COUPE TWIN HEADLAMP', 'Coupe cu faruri duble'],
            ['CROSSOVER SUV BI-XENON', 'SUV crossover cu faruri bi-xenon'],
            ['CROSSOVER SUV HID XENON', 'SUV crossover cu faruri xenon HID'],
            ['CROSSOVER SUV LED HEADLIGHTS', 'SUV crossover cu faruri LED'],
            ['CROSSOVER HID XENON', 'Crossover cu faruri xenon HID'],
            ['ESTATE DOUBLE HEADLAMP', 'Break cu faruri duble'],
            ['ESTATE LED HEADLIGHTS', 'Break cu faruri LED'],
            ['ESTATE MCV TWIN HEADLAMP', 'Break MCV cu faruri duble'],
            ['ESTATE TWIN HEADLIGHT', 'Break cu faruri duble'],
            ['ESTATE XENON HEADLIGHTS', 'Break cu faruri xenon'],
            ['ESTATE XENON HID', 'Break cu faruri xenon HID'],
            ['GRAN COUPE HID XENON', 'Gran Coupe cu faruri xenon HID'],
            ['GRAN COUPE LED HEADLIGHTS', 'Gran Coupe cu faruri LED'],
            ['GRAN TOURISMO HID XENON', 'Gran Turismo cu faruri xenon HID'],
            ['GRAND TURISMO HID XENON', 'Grand Turismo cu faruri xenon HID'],
            ['GRANDTOUR HID XENON', 'Grandtour cu faruri xenon HID'],
            ['GTC / SPORTS HATCH\tXENON HID', 'GTC / hatchback sport cu faruri xenon HID'],
            ['GTC HALOGEN HEADLIGHTS', 'GTC cu faruri cu halogen'],
            ['GTC XENON HID', 'GTC cu faruri xenon HID'],
            ['HATCHBACK BI-HALOGEN', 'Hatchback cu faruri bi-halogen'],
            ['HATCHBACK BI-XENON HEADLIGHTS', 'Hatchback cu faruri bi-xenon'],
            ['HATCHBACK DOUBLE HEADLAMP', 'Hatchback cu faruri duble'],
            ['HATCHBACK LED HEADLIGHTS', 'Hatchback cu faruri LED'],
            ['HATCHBACK TWIN HEADLAMPS', 'Hatchback cu faruri duble'],
            ['HATCHBACK TWIN HEADLIGHT', 'Hatchback cu faruri duble'],
            ['HATCHBACK XENON HEADLIGHTS', 'Hatchback cu faruri xenon'],
            ['HATCHBACK Xenon Headlights', 'Hatchback cu faruri xenon'],
            ['HATCHBACK XENON HID', 'Hatchback cu faruri xenon HID'],
            ['HATCHBACK  HID XENON', 'Hatchback cu faruri xenon HID'],
            ['MINIVAN HID XENON', 'Monovolum cu faruri xenon HID'],
            ['MPV HALOGEN HEADLIGHTS', 'MPV cu faruri cu halogen'],
            ['MPV HID BI-XENON', 'MPV cu faruri bi-xenon HID'],
            ['MPV LED HEADLIGHTS', 'MPV cu faruri LED'],
            ['ROADSTER HID XENON', 'Roadster cu faruri xenon HID'],
            ['SALOON BI-HALOGEN', 'Sedan cu faruri bi-halogen'],
            ['SALOON DOUBLE HEADLAMP', 'Sedan cu faruri duble'],
            ['SALOON HID BI-XENON', 'Sedan cu faruri bi-xenon HID'],
            ['SALOON TWIN HEADLIGHT HID XENON', 'Sedan cu faruri duble xenon HID'],
            ['SALOON TWIN HEADLIGHT', 'Sedan cu faruri duble'],
            ['SALOON XENON HEADLIGHTS', 'Sedan cu faruri xenon'],
            ['SALOON XENON HID', 'Sedan cu faruri xenon HID'],
            ['SPORTBACK LED HEADLIGHTS', 'Sportback cu faruri LED'],
            ['SPORTBRAKE HID XENON', 'Sportbrake cu faruri xenon HID'],
            ['SPORTS WAGON HID XENON', 'Break sport cu faruri xenon HID'],
            ['SUV BI HALOGEN HEADLAMP', 'SUV cu faruri bi-halogen'],
            ['SUV BI-HALOGEN', 'SUV cu faruri bi-halogen'],
            ['SUV BI-XENON HEADLIGHTS', 'SUV cu faruri bi-xenon'],
            ['SUV HID BI-XENON', 'SUV cu faruri bi-xenon HID'],
            ['SUV TWIN HEADLIGHT', 'SUV cu faruri duble'],
            ['SUV WITH BI HALOHEN HEADLIGHTS', 'SUV cu faruri bi-halogen'],
            ['SUV XENON HID', 'SUV cu faruri xenon HID'],
            ['VAN BI-XENON HEADLIGHTS', 'Furgonetă cu faruri bi-xenon'],
            ['VAN DOUBLE HEADLAMP', 'Furgonetă cu faruri duble'],
            ['VAN HALOGEN HEADLIGHTS', 'Furgonetă cu faruri cu halogen'],
            ['VAN HID XENON', 'Furgonetă cu faruri xenon HID'],
            ['VAN TWIN HEADLAMP', 'Furgonetă cu faruri duble'],
            ['VAN XENON HEADLAMP', 'Furgonetă cu faruri xenon'],
            ['HID XENON HEADLAMPS', 'Faruri xenon HID'],
            ['HID XENON', 'Xenon HID'],
            ['SINGLE HEADLIGHT HALOGEN', 'Un singur far cu halogen'],
            ['TWIN HEADLIGHT HALOGEN', 'Faruri duble cu halogen'],
            ['AVANT LED HEADLIGHTS', 'Avant cu faruri LED'],
            ['AVANT XENON HID', 'Avant cu faruri xenon HID'],
            ['ACTIVE TOURER', 'Active Tourer'],
            ['GRAN TOURER', 'Gran Tourer'],
            ['GRAN TOURISMO', 'Gran Turismo'],
            ['GT HATCHBACK', 'Hatchback GT'],
            ['GTC / SPORTS HATCH', 'GTC / hatchback sport'],
            ['SPORTS WAGON', 'Break sport'],
            ['SPORTBRAKE', 'Sportbrake'],
            ['CROSSOVER SUV', 'SUV crossover'],
            ['CROSSOVER', 'Crossover'],
            ['PANEL VAN', 'Autoutilitară tip furgon'],
            ['CHASSIS CAB', 'Șasiu cu cabină'],
            ['CREW CAB', 'Cabină dublă'],
            ['PICKUP DOUBLE HEADLAMP', 'Pick-up cu faruri duble'],
            ['PICK UP TWIN HEADLIGHT', 'Pick-up cu faruri duble'],
            ['PICK-UP', 'Pick-up'],
            ['PV- TAILGATE', 'Furgonetă cu hayon'],
            ['VAN TAILGATE', 'Furgonetă cu hayon'],
            ['HARD TOP', 'Hardtop'],
            ['TARGA TOP', 'Targa'],
            ['TWIN TOP', 'TwinTop'],
            ['OFF ROAD', 'Off-road'],
            ['TRUCK', 'Camion'],
            ['WITHOUT CORNERING LIGHTS', 'Fără lumini de viraj'],
            ["WITH DRL'S", 'Cu lumini de zi'],
            ['WITH DRL', 'Cu lumini de zi'],
            ['LED DRL', 'Lumini de zi LED'],
            ['(no DRL)', '(fără lumini de zi)'],
            ['(with DRL)', '(cu lumini de zi)'],
            ['Халогенни фарове с LED дневни светлини', 'Faruri cu halogen și lumini de zi LED'],
            ['Халогенни фарове без дневни светлини', 'Faruri cu halogen fără lumini de zi'],
            ['Хечбек с халогенни дневни светлини', 'Hatchback cu lumini de zi cu halogen'],
            ['с ксенонови HID фарове', 'cu faruri xenon HID'],
            ['с халогенни фарове', 'cu faruri cu halogen'],
            ['с LED фарове', 'cu faruri LED'],
            ['с двойни фарове', 'cu faruri duble'],
            ['с единичен фар', 'cu un singur far'],
            ['без дневни светлини', 'fără lumini de zi'],
            ['Би-халогенни фарове', 'Faruri bi-halogen'],
            ['Би-ксенонов фар', 'Far bi-xenon'],
            ['Двоен халогенен фар', 'Far dublu cu halogen'],
            ['Двойни халогенни фарове', 'Faruri duble cu halogen'],
            ['Единичен халогенен фар', 'Far cu halogen simplu'],
            ['Ксенонови HID фарове', 'Faruri xenon HID'],
            ['Халогенни фарове', 'Faruri cu halogen'],
            ['LED фарове', 'Faruri LED'],
            ['Дълги светлини', 'Fază lungă'],
            ['Къси Светлини', 'Fază scurtă'],
            ['Светлини за Мъгла', 'Proiectoare de ceață'],
            ['Двоен фар', 'Far dublu'],
            ['Единичен фар', 'Far simplu'],
            ['Спортно комби', 'Break sport'],
            ['Комби Avant', 'Break Avant'],
            ['Комби MCV', 'Break MCV'],
            ['Комби (Crayford)', 'Break (Crayford)'],
            ['Комби', 'Break'],
            ['Кабриолет елипсоид', 'Cabriolet cu faruri elipsoidale'],
            ['Кабриолет', 'Cabriolet'],
            ['Компакт', 'Compact'],
            ['Купе', 'Coupe'],
            ['Лифтбек', 'Liftback'],
            ['Минибус', 'Microbuz'],
            ['Миниван', 'Monovolum'],
            ['Мултиван', 'Multivan'],
            ['Офроуд', 'Off-road'],
            ['Пикап', 'Pick-up'],
            ['Пикасо', 'Picasso'],
            ['Роудстър', 'Roadster'],
            ['Седан', 'Sedan'],
            ['Спайдър', 'Spider'],
            ['Спортбек', 'Sportback'],
            ['Спорт', 'Sport'],
            ['Такси', 'Taxi'],
            ['Тарга', 'Targa'],
            ['Турер', 'Tourer'],
            ['Туринг', 'Touring'],
            ['Фастбек', 'Fastback'],
            ['Хечбек', 'Hatchback'],
            ['Ван', 'Furgonetă'],
            ['с 2 врати', 'cu 2 uși'],
            ['с 3 врати', 'cu 3 uși'],
            ['с 4 врати', 'cu 4 uși'],
            ['с 5 врати', 'cu 5 uși']
        ]
        }
  };

  const localeTranslations = translationsByLocale[currentLocale];

  if (!localeTranslations) {
    return;
  }

  const translateText = (sourceText) => {
    const normalizedText = sourceText.trim();
    const exactTranslation = localeTranslations.exact[normalizedText];

    if (exactTranslation) {
      return exactTranslation;
    }

    return localeTranslations.phrases.reduce(
      (translatedText, [sourcePhrase, translatedPhrase]) =>
        translatedText.replaceAll(sourcePhrase, translatedPhrase),
      normalizedText
    );
  };

  const translateElement = (element) => {
    const translatedText = translateText(element.textContent);

    if (translatedText !== element.textContent.trim()) {
      element.textContent = translatedText;
    }
  };

const visualTextSelector = [
  '.ss-option',
  '.ss-main .placeholder',
  '.ss-main .ss-single',
  '.ss-single-selected .placeholder'
].join(',');

const translateVisualNode = (node) => {
  if (!(node instanceof Element)) {
    return;
  }

  if (node.matches(visualTextSelector)) {
    translateElement(node);
  }

  node.querySelectorAll(visualTextSelector).forEach(translateElement);
};

const translateCurrentOptions = () => {
  document
    .querySelectorAll(visualTextSelector)
    .forEach(translateElement);
};

const handleVisualChanges = (mutationRecords) => {
  mutationRecords.forEach((mutationRecord) => {
    if (
      mutationRecord.target instanceof Element &&
      mutationRecord.target.matches(visualTextSelector)
    ) {
      translateElement(mutationRecord.target);
    }

    mutationRecord.addedNodes.forEach(translateVisualNode);
  });
};

translateCurrentOptions();

const visualOptionsObserver = new MutationObserver(handleVisualChanges);

visualOptionsObserver.observe(document.body, {
  childList: true,
  subtree: true
});
})();
